import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ExportsProvider } from "@/context/ExportsContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Practices from "@/pages/Practices";
import PracticeDetail from "@/pages/PracticeDetail";
import Anagrafiche from "@/pages/Anagrafiche";
import Users from "@/pages/Users";
import ImportData from "@/pages/ImportData";
import Sedi from "@/pages/Sedi";
import Products from "@/pages/Products";
import Marketing from "@/pages/Marketing";
import CampaignDetail from "@/pages/CampaignDetail";
import Calendar from "@/pages/Calendar";
import LeadDetail from "@/pages/LeadDetail";
import RubricaLead from "@/pages/RubricaLead";
import Amministrazione from "@/pages/Amministrazione";
import Comunicazioni from "@/pages/Comunicazioni";
import RegistroImport from "@/pages/RegistroImport";
import Soppressioni from "@/pages/Soppressioni";
import SignPage from "@/pages/SignPage";
import ForcePasswordChange from "@/pages/ForcePasswordChange";

function Protected({ children, allow }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  if (allow && !allow.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

const INTERNAL = ["admin", "collaboratore"];
const ADMIN = ["admin"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ExportsProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/firma/:token" element={<SignPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/pratiche" element={<Protected><Practices /></Protected>} />
            <Route path="/pratiche/:id" element={<Protected><PracticeDetail /></Protected>} />
            <Route path="/anagrafiche" element={<Protected><Anagrafiche /></Protected>} />
            <Route path="/utenti" element={<Protected allow={INTERNAL}><Users /></Protected>} />
            <Route path="/importa" element={<Protected allow={ADMIN}><ImportData /></Protected>} />
            <Route path="/sedi" element={<Protected allow={ADMIN}><Sedi /></Protected>} />
            <Route path="/prodotti" element={<Protected allow={ADMIN}><Products /></Protected>} />
            <Route path="/marketing" element={<Protected allow={INTERNAL}><Marketing /></Protected>} />
            <Route path="/marketing/rubrica" element={<Protected allow={INTERNAL}><RubricaLead /></Protected>} />
            <Route path="/marketing/soppressioni" element={<Protected allow={ADMIN}><Soppressioni /></Protected>} />
            <Route path="/marketing/rubrica/lead/:lid" element={<Protected allow={INTERNAL}><LeadDetail /></Protected>} />
            <Route path="/marketing/:id" element={<Protected allow={INTERNAL}><CampaignDetail /></Protected>} />
            <Route path="/marketing/:cid/lead/:lid" element={<Protected allow={INTERNAL}><LeadDetail /></Protected>} />
            <Route path="/calendario" element={<Protected allow={INTERNAL}><Calendar /></Protected>} />
            <Route path="/amministrazione" element={<Protected allow={["admin", "collaboratore", "segnalatore", "convenzionato", "istituto"]}><Amministrazione /></Protected>} />
            <Route path="/comunicazioni" element={<Protected><Comunicazioni /></Protected>} />
            <Route path="/registro-import" element={<Protected allow={INTERNAL}><RegistroImport /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ExportsProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
